var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 78"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 67.986C53.315 67.456 68 52.443 68 34 68 15.222 52.778 0 34 0S0 15.222 0 34s15.222 34 34 34v5.05a2.5 2.5 0 1 0 1 0z",
    clipRule: "evenodd"
  })));
};
export default SvgPin;